const modals = [
    "sampleSummary",
    "medicalKit",
    "apiResponse", 
    "requestSample", 
    "showImage", 
    "labContact", 
    "closeSesion", 
    "resetPassword",
    "popUpStatus",
    "tutorial",
]
export default modals;
